import * as React from 'react'
import clx from 'classnames'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { NewsItem } from '@/modules/shared/query-client/useQueryNews'
import { formatNewsDate, newsAppearance } from './newsMeta'

type Props = {
  item: NewsItem
  highlighted?: boolean
  variant?: 'card' | 'compact'
}

export const NewsEntry: React.FC<Props> = ({
  item,
  highlighted = false,
  variant = 'card',
}) => {
  const { tSafe } = useLocalize()
  const date = formatNewsDate(item)
  const compact = variant === 'compact'
  const appearance = newsAppearance(item.type)

  return (
    <article
      className={clx(
        'tw-flex tw-flex-col tw-overflow-hidden tw-rounded-lg tw-border',
        compact ? 'tw-p-2.5' : 'tw-p-3.5',
        highlighted
          ? 'tw-border-primary/30 tw-bg-base-100'
          : 'tw-border-base-300 tw-bg-base-200',
      )}
    >
      <header className="tw-flex tw-items-center tw-gap-2">
        <span
          className={clx(
            'tw-inline-flex tw-shrink-0 tw-items-center tw-rounded-full tw-px-2 tw-py-0.5 tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wide',
            appearance.pillClassName,
          )}
        >
          {tSafe(appearance.labelKey, appearance.labelFallback)}
        </span>
        {date && (
          <span className="tw-ml-auto tw-shrink-0 tw-text-[11px] tw-text-neutral">
            {date}
          </span>
        )}
      </header>

      <h3
        className={clx(
          'tw-mb-0 tw-mt-2 tw-font-semibold tw-text-content-base',
          compact ? 'tw-text-[13px]' : 'tw-text-sm',
        )}
      >
        {item.title}
      </h3>

      {item.description && (
        <p
          className={clx(
            'tw-mb-0 tw-mt-1 tw-whitespace-pre-line tw-text-content-base/80',
            compact ? 'tw-text-[12px]' : 'tw-text-[13px]',
          )}
        >
          {item.description}
        </p>
      )}
    </article>
  )
}
